import { Role as RoleData } from '../const';
import MenuInput from './MenuInput';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import sty from '../styles/Roles.module.css';
import { func, object } from 'prop-types';

/**
 * @component Role
 * @param { Object } props
 * @param { object } props.role
 * @param { function } props.onCheck
 * @param { function } props.onHandle
 * @return { JSX.Element }
 */
function Role(props) {
	return (
		<>
			<section className={sty.role_section}>
				<Checkbox
					checked={props.role[RoleData.Checked]}
					onClick={() => props.onCheck(props.role[RoleData.Id])}
				/>
				<MenuInput
					id={props.role[RoleData.Id]}
					name="name"
					value={props.role.name}
					onHandle={props.onHandle}
				/>
				<MenuInput
					id={props.role[RoleData.Id]}
					name="desc"
					value={props.role.desc}
					onHandle={props.onHandle}
				/>
				<MenuInput
					id={props.role[RoleData.Id]}
					name="type"
					value={props.role.type}
					onHandle={props.onHandle}
				/>
			</section>
			<Divider className={sty.role_list_list_divider} />
		</>
	);
}

Role.propTypes = {
	role: object,
	onCheck: func,
	onHandle: func,
};

export default Role;
